import { render, staticRenderFns } from "./ConversationSidebar.vue?vue&type=template&id=4a00de7e&scoped=true&"
import script from "./ConversationSidebar.vue?vue&type=script&lang=js&"
export * from "./ConversationSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ConversationSidebar.vue?vue&type=style&index=0&id=4a00de7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a00de7e",
  null
  
)

export default component.exports